"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageMessage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var useStyles = (0, _makeStyles.default)(function () {
  return {
    message: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: 200
    }
  };
});
function PageMessage(_ref) {
  var actionKey = _ref.actionKey,
    actionLink = _ref.actionLink,
    actionProps = _ref.actionProps,
    id = _ref.id,
    messageKey = _ref.messageKey,
    messageProps = _ref.messageProps;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.message,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    gutterBottom: true,
    id: "".concat(id, "Message")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, (0, _extends2.default)({
    id: messageKey
  }, messageProps))), actionKey && /*#__PURE__*/_react.default.createElement(_material.Button, (0, _extends2.default)({
    color: "primary",
    component: actionLink ? _reactRouterDom.Link : _material.Button,
    id: "".concat(id, "Button"),
    to: actionLink || undefined,
    variant: "contained"
  }, actionProps), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: actionKey
  })));
}